import styled from "@emotion/styled"
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper"
import BenefitsCardCharge from "pazChargeComponents/Home/BenefitsCharge"
import { NewText, TitleWithLine, extractProperty } from "ui"

const StyledWrapper = styled.div`
padding-top: 60px;
padding-bottom: 60px;
${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 60px;
  }

background: rgba(21, 62, 105, 0.1);
`
const StyledTitleAndText = styled.div`
    p {
    margin-top: 10px;
    margin-bottom: 10px;
}
${(props) => props.theme.breakpoints.up("md")} {
  }
`
const StyledLayout = styled.div`
    display: flex;
    flex-direction: column;
${(props) => props.theme.breakpoints.up("lg")} {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: center;
  align-items: center;
  gap: 140px;
  }
`
const StyledBenefit = styled.div`
padding-top: 20px;
display: grid;
grid-template-columns: repeat(2, 1fr);
justify-content: center;
z-index: 5;
gap: 10px;
${(props) => props.theme.breakpoints.up("md")} {
    justify-content: start;
    grid-template-columns: repeat(2, max-content);
  }
`
const StyledBenefitWrapper = styled.div`
`

function ChargeBenefitsContentBlock({ data }: { data: any }) {

    const blockTitle = extractProperty(data, "blockTitle")
    const content = extractProperty(data, "content")
    const benefitsItems = extractProperty(data, "benefitsItems")
    return (
        <StyledWrapper>
            <ContainerWrapper>
                <StyledLayout>
                    <StyledTitleAndText>
                        <TitleWithLine
                            title={blockTitle}
                            component={"h2"}
                            titleColor="black"
                            titleFontSize={34}
                            largeDesktopFontSize={34}
                            mobileTitleFontSize={28}
                            noMobileMargin
                        />
                        <NewText
                            component={"p"}
                            largeDesktopFontSize={18}
                            largeDesktopLineHeight="20px"
                            desktopFontSize={18}
                            desktopLineHeight={"20px"}
                            desktopFontWeight={400}
                            mobileFontSize={16}
                            mobileLineHeight={"18px"}
                            mobileFontWeight={400}
                            dangerouslySetInnerHTML={{ __html: content }}
                        />
                    </StyledTitleAndText>
                    <StyledBenefitWrapper>
                        <StyledBenefit>
                            {benefitsItems.map((benefit: any, index: number) => {
                                const title = extractProperty(benefit, "title")
                                const icon = extractProperty(benefit, "icon")
                                const description = extractProperty(benefit, "description")
                                return (
                                    <BenefitsCardCharge key={index} index={index} {...{ title, icon, description, mediumDesktopWidth: 319 }} />
                                )
                            })}

                        </StyledBenefit>
                    </StyledBenefitWrapper>
                </StyledLayout>
            </ContainerWrapper>
        </StyledWrapper >
    )
}

export default ChargeBenefitsContentBlock
